export default "__VITE_ASSET__C6uKN$lM__"